{
  "labels": {
    "paste": "貼上",
    "pasteAsPlaintext": "",
    "pasteCharts": "貼上圖表",
    "selectAll": "全選",
    "multiSelect": "多重選取",
    "moveCanvas": "移動畫布",
    "cut": "剪下",
    "copy": "複製",
    "copyAsPng": "以 PNG 格式複製",
    "copyAsSvg": "以 SVG 格式複製",
    "copyText": "",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "往上一層移動",
    "sendToBack": "移到最底層",
    "bringToFront": "移到最上層",
    "sendBackward": "往下一層移動",
    "delete": "刪除",
    "copyStyles": "複製樣式",
    "pasteStyles": "套用樣式",
    "stroke": "筆跡顏色",
    "changeStroke": "",
    "background": "填充顏色",
    "changeBackground": "",
    "fill": "背景樣式",
    "strokeWidth": "筆跡寬度",
    "strokeStyle": "筆跡線條",
    "strokeStyle_solid": "實線",
    "strokeStyle_dashed": "虛線（較密）",
    "strokeStyle_dotted": "虛線（較疏）",
    "sloppiness": "筆跡風格",
    "opacity": "透明度",
    "textAlign": "文字對齊",
    "edges": "邊角樣式",
    "sharp": "銳角",
    "round": "圓角",
    "arrowheads": "箭嘴",
    "arrowhead_none": "無箭嘴",
    "arrowhead_arrow": "普通箭嘴",
    "arrowhead_bar": "平頭條狀",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "三角箭嘴",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "arrowhead_crowfoot_many": "",
    "arrowhead_crowfoot_one": "",
    "arrowhead_crowfoot_one_or_many": "",
    "more_options": "",
    "arrowtypes": "",
    "arrowtype_sharp": "",
    "arrowtype_round": "",
    "arrowtype_elbowed": "",
    "fontSize": "字型大小",
    "fontFamily": "字體",
    "addWatermark": "加入「使用 Excalidraw 製圖」水印",
    "handDrawn": "手繪體",
    "normal": "電腦字體",
    "code": "等寬體",
    "small": "細",
    "medium": "中",
    "large": "大",
    "veryLarge": "勁大",
    "solid": "實心",
    "hachure": "斜線",
    "zigzag": "",
    "crossHatch": "交叉格仔",
    "thin": "幼",
    "bold": "粗",
    "left": "靠左對齊",
    "center": "置中對齊",
    "right": "靠右對齊",
    "extraBold": "勁粗",
    "architect": "手繪風格",
    "artist": "藝術家風格",
    "cartoonist": "卡通風格",
    "fileTitle": "檔案名稱",
    "colorPicker": "",
    "canvasColors": "",
    "canvasBackground": "畫布背景顏色",
    "drawingCanvas": "畫布",
    "clearCanvas": "",
    "layers": "圖層",
    "actions": "動作",
    "language": "🌏 語言",
    "liveCollaboration": "",
    "duplicateSelection": "製作副本",
    "untitled": "未命名的作品",
    "name": "",
    "yourName": "你的名稱",
    "madeWithExcalidraw": "使用 Excalidraw 製圖",
    "group": "建立物件群組",
    "ungroup": "取消物件群組",
    "collaborators": "已連線的協作者",
    "toggleGrid": "",
    "addToLibrary": "加入作品庫",
    "removeFromLibrary": "從作品庫中移除",
    "libraryLoadingMessage": "正在載入作品庫…",
    "libraries": "瀏覽作品庫",
    "loadingScene": "載入畫布中…",
    "loadScene": "",
    "align": "物件對齊",
    "alignTop": "水平置頂",
    "alignBottom": "水平置底",
    "alignLeft": "垂直靠左對齊",
    "alignRight": "垂直靠右對齊",
    "centerVertically": "垂直置中",
    "centerHorizontally": "水平置中",
    "distributeHorizontally": "左右等距",
    "distributeVertically": "上下等距",
    "flipHorizontal": "左右反轉",
    "flipVertical": "上下反轉",
    "viewMode": "唯讀模式",
    "share": "",
    "showStroke": "",
    "showBackground": "",
    "showFonts": "",
    "toggleTheme": "",
    "theme": "",
    "personalLib": "",
    "excalidrawLib": "",
    "decreaseFontSize": "",
    "increaseFontSize": "",
    "unbindText": "",
    "bindText": "",
    "createContainerFromText": "",
    "link": {
      "edit": "",
      "editEmbed": "",
      "create": "",
      "label": "",
      "labelEmbed": "",
      "empty": "",
      "hint": "",
      "goToElement": ""
    },
    "lineEditor": {
      "edit": "",
      "editArrow": ""
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": ""
    },
    "elementLock": {
      "lock": "",
      "unlock": "",
      "lockAll": "",
      "unlockAll": ""
    },
    "statusPublished": "",
    "sidebarLock": "",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "",
    "textToDiagram": "",
    "prompt": "",
    "followUs": "",
    "discordChat": "",
    "zoomToFitViewport": "",
    "zoomToFitSelection": "",
    "zoomToFit": "",
    "installPWA": "",
    "autoResize": "",
    "imageCropping": "",
    "unCroppedDimension": "",
    "copyElementLink": "",
    "linkToElement": "",
    "wrapSelectionInFrame": "",
    "tab": "",
    "shapeSwitch": ""
  },
  "elementLink": {
    "title": "",
    "desc": "",
    "notFound": ""
  },
  "library": {
    "noItems": "",
    "hint_emptyLibrary": "",
    "hint_emptyPrivateLibrary": "",
    "search": {
      "inputPlaceholder": "",
      "heading": "",
      "noResults": "",
      "clearSearch": ""
    }
  },
  "search": {
    "title": "",
    "noMatch": "",
    "singleResult": "",
    "multipleResults": "",
    "placeholder": "",
    "frames": "",
    "texts": ""
  },
  "buttons": {
    "clearReset": "清空畫布",
    "exportJSON": "",
    "exportImage": "",
    "export": "",
    "copyToClipboard": "",
    "copyLink": "",
    "save": "",
    "saveAs": "",
    "load": "",
    "getShareableLink": "",
    "close": "",
    "selectLanguage": "",
    "scrollBackToContent": "",
    "zoomIn": "",
    "zoomOut": "",
    "resetZoom": "",
    "menu": "",
    "done": "",
    "edit": "",
    "undo": "",
    "redo": "",
    "resetLibrary": "",
    "createNewRoom": "",
    "fullScreen": "",
    "darkMode": "",
    "lightMode": "",
    "systemMode": "",
    "zenMode": "",
    "objectsSnapMode": "",
    "exitZenMode": "",
    "cancel": "",
    "saveLibNames": "",
    "clear": "",
    "remove": "",
    "embed": "",
    "publishLibrary": "",
    "submit": "",
    "confirm": "",
    "embeddableInteractionButton": ""
  },
  "alerts": {
    "clearReset": "【‼️ 警告 ‼️ 無法復原的動作】你確定要清空呢塊畫布嗎？",
    "couldNotCreateShareableLink": "",
    "couldNotCreateShareableLinkTooBig": "",
    "couldNotLoadInvalidFile": "",
    "importBackendFailed": "",
    "cannotExportEmptyCanvas": "無嘢可以匯出喎～畫吓嘢先？",
    "couldNotCopyToClipboard": "",
    "decryptFailed": "",
    "uploadedSecurly": "",
    "loadSceneOverridePrompt": "",
    "collabStopOverridePrompt": "",
    "errorAddingToLibrary": "",
    "errorRemovingFromLibrary": "",
    "confirmAddLibrary": "",
    "imageDoesNotContainScene": "",
    "cannotRestoreFromImage": "",
    "invalidSceneUrl": "",
    "resetLibrary": "",
    "removeItemsFromsLibrary": "",
    "invalidEncryptionKey": "",
    "collabOfflineWarning": "",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "",
    "imageInsertError": "",
    "fileTooBig": "",
    "svgImageInsertError": "",
    "failedToFetchImage": "",
    "cannotResolveCollabServer": "",
    "importLibraryError": "",
    "saveLibraryError": "",
    "collabSaveFailed": "",
    "collabSaveFailed_sizeExceeded": "",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "libraryElementTypeError": {
      "embeddable": "",
      "iframe": "",
      "image": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "",
    "lasso": "",
    "image": "",
    "rectangle": "",
    "diamond": "",
    "ellipse": "",
    "arrow": "",
    "line": "",
    "freedraw": "",
    "text": "",
    "library": "",
    "lock": "",
    "penMode": "",
    "link": "",
    "eraser": "",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "laser": "",
    "hand": "",
    "extraTools": "",
    "mermaidToExcalidraw": "",
    "convertElementType": ""
  },
  "element": {
    "rectangle": "",
    "diamond": "",
    "ellipse": "",
    "arrow": "",
    "line": "",
    "freedraw": "",
    "text": "",
    "image": "",
    "group": "",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "selection": "",
    "iframe": ""
  },
  "headings": {
    "canvasActions": "畫布動作",
    "selectedShapeActions": "",
    "shapes": ""
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "",
    "linearElement": "",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "",
    "text": "",
    "embeddable": "",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "publishLibrary": "",
    "bindTextToElement": "",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "無法顯示預覽",
    "canvasTooBig": "塊畫布太大啦，縮細啲先啦？",
    "canvasTooBigTip": ""
  },
  "errorSplash": {
    "headingMain": "",
    "clearCanvasMessage": "如果重新整理頁面都係睇唔到，你可以<button>清空畫布</button>",
    "clearCanvasCaveat": "（注意：呢個動作會直接丟棄你嘅作品，並且無法復原）",
    "trackedToSentry": "",
    "openIssueMessage": "",
    "sceneContent": ""
  },
  "shareDialog": {
    "or": ""
  },
  "roomDialog": {
    "desc_intro": "",
    "desc_privacy": "",
    "button_startSession": "",
    "button_stopSession": "",
    "desc_inProgressIntro": "",
    "desc_shareLink": "",
    "desc_exitSession": "",
    "shareTitle": ""
  },
  "errorDialog": {
    "title": ""
  },
  "exportDialog": {
    "disk_title": "",
    "disk_details": "",
    "disk_button": "",
    "link_title": "",
    "link_details": "",
    "link_button": "",
    "excalidrawplus_description": "",
    "excalidrawplus_button": "",
    "excalidrawplus_exportError": ""
  },
  "helpDialog": {
    "blog": "",
    "click": "",
    "deepSelect": "",
    "deepBoxSelect": "",
    "createFlowchart": "",
    "navigateFlowchart": "",
    "curvedArrow": "",
    "curvedLine": "",
    "documentation": "",
    "doubleClick": "",
    "drag": "",
    "editor": "",
    "editLineArrowPoints": "",
    "editText": "",
    "github": "",
    "howto": "",
    "or": "",
    "preventBinding": "",
    "tools": "",
    "shortcuts": "",
    "textFinish": "",
    "textNewLine": "",
    "title": "",
    "view": "",
    "zoomToFit": "",
    "zoomToSelection": "",
    "toggleElementLock": "",
    "movePageUpDown": "",
    "movePageLeftRight": "",
    "cropStart": "",
    "cropFinish": ""
  },
  "clearCanvasDialog": {
    "title": ""
  },
  "publishDialog": {
    "title": "",
    "itemName": "",
    "authorName": "",
    "githubUsername": "",
    "twitterUsername": "",
    "libraryName": "",
    "libraryDesc": "",
    "website": "",
    "placeholder": {
      "authorName": "",
      "libraryName": "",
      "libraryDesc": "",
      "githubHandle": "",
      "twitterHandle": "",
      "website": ""
    },
    "errors": {
      "required": "",
      "website": ""
    },
    "noteDescription": "",
    "noteGuidelines": "",
    "noteLicense": "",
    "noteItems": "",
    "atleastOneLibItem": "",
    "republishWarning": ""
  },
  "publishSuccessDialog": {
    "title": "",
    "content": ""
  },
  "confirmDialog": {
    "resetLibrary": "",
    "removeItemsFromLib": ""
  },
  "imageExportDialog": {
    "header": "",
    "label": {
      "withBackground": "",
      "onlySelected": "",
      "darkMode": "",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    },
    "button": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    }
  },
  "encrypted": {
    "tooltip": "",
    "link": ""
  },
  "stats": {
    "angle": "",
    "shapes": "",
    "height": "",
    "scene": "",
    "selected": "",
    "storage": "",
    "fullTitle": "",
    "title": "",
    "generalStats": "",
    "elementProperties": "",
    "total": "",
    "version": "",
    "versionCopy": "",
    "versionNotAvailable": "",
    "width": ""
  },
  "toast": {
    "addedToLibrary": "",
    "copyStyles": "",
    "copyToClipboard": "",
    "copyToClipboardAsPng": "",
    "copyToClipboardAsSvg": "",
    "fileSaved": "",
    "fileSavedToFilename": "",
    "canvas": "畫布",
    "selection": "",
    "pasteAsSingleElement": "",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": "",
    "elementLinkCopied": ""
  },
  "colors": {
    "transparent": "",
    "black": "",
    "white": "",
    "red": "",
    "pink": "",
    "grape": "",
    "violet": "",
    "gray": "",
    "blue": "",
    "cyan": "",
    "teal": "",
    "green": "",
    "yellow": "",
    "orange": "",
    "bronze": ""
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "",
      "menuHint": ""
    },
    "defaults": {
      "menuHint": "",
      "center_heading": "",
      "toolbarHint": "",
      "helpHint": ""
    }
  },
  "colorPicker": {
    "color": "",
    "mostUsedCustomColors": "",
    "colors": "",
    "shades": "",
    "hexCode": "",
    "noShades": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "",
        "button": "",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "",
        "button": "",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": "",
    "label": "",
    "inputPlaceholder": ""
  },
  "ttd": {
    "error": ""
  },
  "chat": {
    "inputPlaceholder": "",
    "inputPlaceholderWithMessages": "",
    "generating": "",
    "rateLimitRemaining": "",
    "role": {
      "user": "",
      "assistant": "",
      "system": ""
    },
    "aiBeta": "",
    "label": "",
    "menu": "",
    "newChat": "",
    "deleteChat": "",
    "deleteMessage": "",
    "viewAsMermaid": "",
    "placeholder": {
      "title": "",
      "description": "",
      "hint": ""
    },
    "preview": "",
    "insert": "",
    "retry": "",
    "errors": {
      "promptTooShort": "",
      "promptTooLong": "",
      "generationFailed": "",
      "invalidDiagram": "",
      "fixInMermaid": "",
      "aiRepair": "",
      "requestAborted": "",
      "requestFailed": "",
      "mermaidParseError": ""
    },
    "rateLimit": {
      "messageLimit": "",
      "generalRateLimit": "",
      "messageLimitInputPlaceholder": ""
    },
    "upsellBtnLabel": ""
  },
  "quickSearch": {
    "placeholder": ""
  },
  "fontList": {
    "badge": {
      "old": ""
    },
    "sceneFonts": "",
    "availableFonts": "",
    "empty": ""
  },
  "userList": {
    "empty": "",
    "hint": {
      "text": "",
      "followStatus": "",
      "inCall": "",
      "micMuted": "",
      "isSpeaking": ""
    }
  },
  "commandPalette": {
    "title": "",
    "shortcuts": {
      "select": "",
      "confirm": "",
      "close": ""
    },
    "recents": "",
    "search": {
      "placeholder": "",
      "noMatch": ""
    },
    "itemNotAvailable": "",
    "shortcutHint": ""
  },
  "keys": {
    "ctrl": "",
    "option": "",
    "cmd": "",
    "alt": "",
    "escape": "",
    "enter": "",
    "shift": "",
    "spacebar": "",
    "delete": "",
    "mmb": ""
  }
}
